import { ITranslationMetadata } from 'shared/models/translation/models';

export enum ActivityKind {
    ACTIVITY = 'ACTIVITY',
    HEADING = 'HEADING',
}

export interface IActivity {
    id: number;
    tenant_id: number;
    course_id: number;
    name: string;
    kind: ActivityKind;
    is_published: boolean;
    is_paid?: boolean;
    translation_metadata?: ITranslationMetadata;
}

export interface ICreateActivityForm {
    name: string;
    is_published: boolean;
    is_paid: boolean;
    kind: ActivityKind;
}

export interface IUpdateActivity {
    name?: string;
    is_published?: boolean;
    is_paid?: boolean;
}

export interface IActivitySection {
    header?: IActivity;
    activities: IActivity[];
}